import { CardMediaPill } from '@app/components/base/CardMediaPill';
import { AppCardMediaOverlay } from '@app/components/base/app-card';
import { UploadedPlatformsStatus } from '@app/modules/social-export/components/UploadedPlatformsStatus';
import { getDisplayPlatformItems } from '@app/modules/social-export/lib/get-display-platform-items';
import { EditCardMediaPlaceholder } from '@app/modules/video-editions/components/edit-card/EditCardMediaPlaceholder';
import { EditCardThumbnail } from '@app/modules/video-editions/components/edit-card/EditCardThumbnail';
import { webApi } from '@mi-front/api-clients';
import { Box } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

import { getCompositionListThumbnailSrc } from './get-composition-list-thumbnail-src';

const composeListCardUnpublishedMessage = defineMessage({
  id: 'compose.listCard.unpublished',
  defaultMessage: 'Sin publicar',
});

/**
 * Top media for a composition list card: last edit with a thumbnail URL, or the same
 * empty state as video edition edit cards. Top-right pill shows aggregated social upload
 * statuses when present, otherwise "Sin publicar".
 */
export function CompositionCardMedia({
  composition,
}: {
  composition: webApi.EnrichedCompositionListItemDto;
}) {
  const { formatMessage: $t } = useIntl();
  const thumbnailSrc = getCompositionListThumbnailSrc(composition.edits);
  const platformItems = getDisplayPlatformItems({
    uploadStatuses: composition.uploadStatuses,
  });
  const hasSocialStatuses = platformItems.length > 0;

  const baseMedia = thumbnailSrc ? (
    <EditCardThumbnail src={thumbnailSrc} />
  ) : (
    <EditCardMediaPlaceholder />
  );

  return (
    <Box sx={{ position: 'relative', flexShrink: 0 }}>
      <Box sx={{ position: 'relative', zIndex: 0, flexShrink: 0 }}>{baseMedia}</Box>
      <AppCardMediaOverlay overlayPosition="top-right">
        <CardMediaPill>
          {hasSocialStatuses ? (
            <UploadedPlatformsStatus variant="pill" size="medium" items={platformItems} />
          ) : (
            $t(composeListCardUnpublishedMessage)
          )}
        </CardMediaPill>
      </AppCardMediaOverlay>
    </Box>
  );
}
